import React, { useEffect } from 'react';
import './Register.scss';

const Register = ({ elementChildren }) => {
  let passwordErrorContainer, capitalError, lowercaseError, numberError;

  useEffect(() => {
    const passwordField = document.getElementById('passwordField');
    passwordErrorContainer = document.getElementById('passwordErrors');
    capitalError = document.getElementById('capitalError');
    lowercaseError = document.getElementById('lowercaseError');
    numberError = document.getElementById('numberError');

    passwordField.addEventListener('keyup', handleKeyEvent);

    passwordField.addEventListener('focus', () => {
      passwordErrorContainer.classList.remove('hidden');
    });

    passwordField.addEventListener('blur', () => {
      passwordErrorContainer.classList.add('hidden');
    });
  }, []);

  // Update classes of password validation errors
  const handleKeyEvent = (e) => {
    const passwordValue = e.target.value;

    passwordErrorContainer.classList.remove('hidden');

    if (passwordValue.length < 1) {
      capitalError.classList.remove('invalid', 'valid');
      lowercaseError.classList.remove('invalid', 'valid');
      numberError.classList.remove('invalid', 'valid');

      return;
    }

    if (passwordValue.match(/[A-Z]/g)) {
      capitalError.classList.remove('invalid');
      capitalError.classList.add('valid');
    } else {
      capitalError.classList.remove('valid');
      capitalError.classList.add('invalid');
    }

    // Validate capital letters
    if (passwordValue.match(/[a-z]/g)) {
      lowercaseError.classList.remove('invalid');
      lowercaseError.classList.add('valid');
    } else {
      lowercaseError.classList.remove('valid');
      lowercaseError.classList.add('invalid');
    }

    // Validate numbers
    if (passwordValue.match(/[0-9]/g)) {
      numberError.classList.remove('invalid');
      numberError.classList.add('valid');
    } else {
      numberError.classList.remove('valid');
      numberError.classList.add('invalid');
    }
  };

  return (
    <section className="c-register background-color-gray">
      <div className="c-register__inner">
        <div className="h2-roobert c-register__title">Sign Up</div>
        <div
          className="c-register__form body-2"
          dangerouslySetInnerHTML={{ __html: elementChildren }}
        />
        <div className="c-register__login">
          <span className="body-2 c-register__login-text">Already have an account?</span>
          <a className="body-2" href="/account/login">
            Log in.
          </a>
        </div>
      </div>
    </section>
  );
};

export default Register;
